<template>
  <div>
    <title-bar-back :title="'用户协议'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="ifrem_pos" :class="{ 'has-scroll': $appSource === 3 }">
      <iframe
        v-if="$appSource !== 3"
        :src="$G('https://www.myaz.com/register/agreement')"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
      <div v-else class="agreement-container">
        <h2 class="title">Milky Cloud平台用户服务协议</h2>

        <p class="date">更新时间：2026年4月10日<br />生效时间：2026年4月10日</p>

        <p><strong>【提示条款】</strong></p>
        <p>
          欢迎您与Milky Cloud及其关联平台（下称“Milky Cloud”）共同签署本《Milky
          Cloud用户服务协议》并使用Milky Cloud系统及其关联平台服务。
        </p>
        <p>
          自本协议发布之日起，Milky Cloud所称“Milky
          Cloud用户服务协议”均指本协议。
        </p>
        <p>
          各条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
        </p>

        <p>
          <strong>【审慎阅读】</strong
          >您在注册/登录时点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是<strong
            ><u
              >免除或者限制责任、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读</u
            ></strong
          >。如您对本协议有任何疑问，可向Milky Cloud客服咨询。
        </p>
        <p>
          <strong>【签约动作】</strong
          >当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或以其他方式选择接受本协议或直接使用了本协议相关服务，即表示你已充分阅读、理解并接受本协议的全部内容，并与Milky
          Cloud达成一致，成为Milky
          Cloud的用户。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，或对协议未充分理解或存有异议，您应立即停止使用。
        </p>

        <h3>一、定义</h3>
        <p>
          <strong>Milky Cloud：</strong>Milky Cloud指研发并提供Milky
          Cloud产品和服务的CODECREST INTERNATIONAL PTY
          LTD，以及其现在或未来设立的相关关联公司的单称或合称，以下称为“Milky
          Cloud”或“我们”。
        </p>
        <p>
          <strong>Milky Cloud服务：</strong>指Milky
          Cloud及其关联公司基于互联网，以包含Milky
          Cloud及其关联平台网站（包括PC、WAP）、客户端、小程序及其他应用程序等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。
        </p>
        <p>
          <strong>Milky Cloud平台经营者：</strong>指Milky
          Cloud及其关联平台服务的提供方，即CODECREST INTERNATIONAL PTY
          LTD。为了更好的为你提供服务，Milky
          Cloud可能会依据市场变化或经营便利自主安排或指定其关联公司、控股公司或Milky
          Cloud认可的第三方公司提供部分或全部的相关服务。为了指代方便，除另有说明外，本协议中提及“Milky
          Cloud”、“我们”时均指向Milky Cloud及其关联平台经营者。
        </p>
        <p>
          <strong>用户：</strong>指已在Milky
          Cloud及其关联平台成功完成注册的法律主体，包括商家和消费者，其中商家是指在Milky
          Cloud为消费者提供服务的公司以及其他合法组织，消费者是指在Milky
          Cloud注册成功、进行购买或浏览等行为的主体。
        </p>
        <p>
          <strong>Milky Cloud规则：</strong>指由Milky
          Cloud及其关联平台不时发布或/及公示的规则，包括在所有Milky
          Cloud及其关联平台规则频道内已经发布及后续发布的全部规则、解读、公告等内容，以及在帮助中心、产品或服务流程内发布的各类规则、实施细则、产品流程说明、公告等。
        </p>

        <h3>二、协议范围</h3>
        <h4>2.1 签约主体</h4>
        <p>
          <strong>【平等主体】</strong>本协议由您与Milky
          Cloud共同缔结，本协议对您与平台经营者均具有合同效力。
        </p>
        <p>
          <strong>【主体信息】</strong>Milky Cloud平台经营者是指经营Milky
          Cloud系统及其关联平台的各法律主体，即“CODECREST INTERNATIONAL PTY
          LTD”。本协议项下，Milky Cloud平台经营者可能根据Milky
          Cloud及其关联平台的业务调整而发生变更，变更后的Milky
          Cloud及其关联平台经营者与您共同履行本协议并向您提供服务，Milky
          Cloud平台经营者的变更不会影响您本协议项下的权益。Milky
          Cloud平台经营者还有可能因为提供新的Milky
          Cloud及其关联平台服务而新增，如您使用新增的Milky
          Cloud及其关联平台服务的，视为您同意新增的Milky
          Cloud及其关联平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
        </p>
        <h4>2.2 补充协议</h4>
        <p>
          由于互联网高速发展，您与Milky
          Cloud及其关联平台签署的本协议列明的条款并不能完整罗列并覆盖您与Milky
          Cloud及其关联平台所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，Milky
          Cloud隐私权政策（或根据协议/规则不时更新的最新隐私权政策，以下同）、Milky
          Cloud平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用Milky
          Cloud及其关联平台服务，视为您同意上述补充协议。
        </p>

        <h3>三、账号注册与使用</h3>
        <h4>3.1 用户资格：</h4>
        <p>
          您确认，在您开始注册和/或登录使用Milky
          Cloud产品或服务前，您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织。如如果你因年龄、智力等因素而不具有相应的民事行为能力，请在法定监护人的陪同下阅读和判断是否同意本协议。如果你是非澳大利亚的用户，你订立或履行本协议以及使用本服务的行为还需要同时遵守你所属和/或所处国家或地区的法律。
        </p>
        <h4>3.2 账号说明</h4>
        <p>
          <strong>【账号获得】</strong
          >当您按照注册页面提示填写信息和/或使用第三方账号授权登录，阅读并同意本协议且完成全部注册和/或登录程序后，您可获得Milky
          Cloud及其关联平台账号并成为Milky Cloud及其关联平台用户。
        </p>
        <p>
          您理解并同意，如不同账号绑定或关联同一手机号、同一支付账户、同一身份证件信息、同一设备号或相同收货信息，前述不同账号将被视为关联账号，Milky
          Cloud有权采取冻结或关闭账号、取消订单、拒绝提供服务等措施。
        </p>
        <p>
          <strong>【账号使用】</strong
          >您有权使用您设置或确认的手机号码、邮箱、第三方账号（以下统称“账号名称”）及您设置的密码（账号名称及密码统称“账号”）登录Milky
          Cloud及其关联平台。
        </p>
        <p>
          您理解并知悉，由于您的Milky Cloud账号关联您的个人信息及Milky
          Cloud商业信息，您的Milky Cloud账号仅限您本人使用。未经Milky
          Cloud同意，您直接或间接授权第三方使用您Milky
          Cloud账号或获取您账号项下信息的行为无效。如Milky Cloud根据Milky
          Cloud平台规则中约定的违约认定程序及标准判断您Milky
          Cloud账号的使用可能危及您的账号安全及/或Milky
          Cloud的信息安全、正常交易秩序的，Milky
          Cloud有权拒绝提供相应服务或终止本协议。
        </p>
        <p>
          <strong>【账号转让】</strong
          >由于用户账号关联用户信用信息，仅当有法律明文规定或生效法律文书，否则您的账号不得以任何方式转让。如您违规转让的，Milky
          Cloud有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。
        </p>
        <p>
          <strong>【实名认证】</strong>作为Milky
          Cloud及其关联平台经营者，为使您更好地使用Milky
          Cloud的各项服务，保障您的账号安全，Milky
          Cloud有权要求您按照相关规定完成实名认证。
        </p>

        <h4>3.3 注册信息管理</h4>
        <p><strong>3.3.1真实合法</strong></p>
        <p>
          <strong>【信息真实】</strong>在使用Milky Cloud服务时，您应当按Milky
          Cloud页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便Milky
          Cloud或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
        </p>
        <p>
          <strong>【信息合法】</strong>您设置的Milky
          Cloud昵称、头像、个性签名等信息不得违反国家法律法规及Milky
          Cloud相关规则的规定，不得出现违法、侵权和不良信息。如Milky
          Cloud及其关联平台发现或第三方投诉您以虚假信息骗取账号注册、登录，或您的昵称、头像、个性签名等信息存在违法、侵权或不良信息的，Milky
          Cloud有权直接采取限期改正、暂停使用、注销账号、收回账号权限等措施，且由此产生的责任及后果均由您自行承担。
        </p>
        <p><strong>3.3.2更新维护</strong></p>
        <p>
          您应当及时更新您提供的信息，在法律有明确规定要求Milky
          Cloud必须对部分用户的信息进行核实的情况下，Milky
          Cloud将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。
        </p>
        <p>
          如Milky Cloud按您最后一次提供的信息与您联系未果、您未按Milky
          Cloud的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及Milky
          Cloud造成的全部损失与不利后果。Milky
          Cloud有权向您发出询问或者要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部Milky
          Cloud服务。
        </p>

        <h4>3.4 账号</h4>
        <p>
          <strong>【账号安全保管义务】</strong
          >您的账号为您自行设置并由您保管，Milky
          Cloud任何时候均不会主动要求您提供您的账号密码。因此，建议您务必保管好您的账号，并确保您在每个上网时段结束时退出登录并以正确步骤离开Milky
          Cloud及其关联平台。
        </p>
        <p>
          账号因您主动泄露、保管不当或因您遭受他人攻击、窃取、诈骗等行为导致的损失及后果，Milky
          Cloud并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
        </p>
        <p>
          <strong>【账号异常】</strong>Milky
          Cloud根据其数据分析及经验判断认为用户账号存在异常活动的，为了降低账号安全风险，Milky
          Cloud有权采取限制登录保护等安全措施。
        </p>
        <p>
          <strong>【账号行为责任自负】</strong>除Milky
          Cloud存在过错外，您应对您账号项下的所有行为结果（包括在线签署各类协议、发布信息、购买商品和/或服务、披露信息等）负责。
        </p>
        <p>
          <strong>【日常维护须知】</strong>如发现任何未经授权使用您账号登录Milky
          Cloud及其关联平台或其他可能导致您账号遭窃、遗失的情况，建议您立即通知Milky
          Cloud，并授权Milky Cloud将该信息同步给支付、物流等机构。您理解Milky
          Cloud及其关联平台对您的任何请求采取行动均需要合理时间，且Milky
          Cloud应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除Milky
          Cloud存在法定过错外，Milky Cloud不承担责任。
        </p>

        <h3>四、Milky Cloud及其关联平台服务及规范</h3>
        <p>
          <strong>【服务概况】</strong>您有权在Milky
          Cloud及其关联平台上享受商品和/或服务的浏览、加购、销售、购买、交易争议处理、信息交流等服务。Milky
          Cloud提供的服务内容众多，具体您可登录Milky Cloud及其关联平台浏览。
        </p>
        <h4>4.1 商品和/或服务的浏览、加购</h4>
        <p>
          在您浏览Milky
          Cloud及其关联平台过程中，我们为您提供了信息分类、关键词检索、筛选、加购等功能，以更好地匹配您的需求。您可以对您感兴趣的商品和/或服务进行加购，关注您所感兴趣的店铺/品牌等。
        </p>
        <h4>4.2 商品和/或服务的购买</h4>
        <p>
          <strong>【购买】</strong>您可以通过Milky
          Cloud及其关联平台购买商品和/或服务，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。
        </p>
        <p>
          您的购买行为应当基于真实的消费需求，不得存在对商品和/或服务实施恶意购买、恶意维权等扰乱Milky
          Cloud及其关联平台正常交易秩序的行为。基于维护Milky
          Cloud及其关联平台交易秩序及交易安全的需要，Milky
          Cloud及其关联平台一旦发现前述情形有权采取关闭订单、限制交易、删除信息、账号限权等处理措施。
        </p>
        <p>
          您理解并同意，除另有明确约定外，您在Milky
          Cloud及其关联平台购买商品和/或服务而发生的应纳税赋及其他费用由您自行承担。您保证遵守相关法律法规的规定，保证购买的商品和/或服务均为您个人合理自用，您愿意接受海关、检验检疫机构及其他监管部门的监管并承担相应法律责任。
        </p>
        <h4>4.3 收货后结算服务</h4>
        <p>
          即第三方代收代付功能：在资金支付完成前，交易相对方不可撤销地授权Milky
          Cloud（或Milky
          Cloud合作的第三方支付服务商、协议银行等）进行资金的代为收取、支付、存放、划转。在使用该功能时，买家点击确认收货或根据买卖双方的约定视为确认收货后，Milky
          Cloud将代为收取的买家支付的款项代为支付给卖家。若买卖双方与相关交易平台就全部或部分交易款项的结算时间存在其他特殊约定的，则按照特殊约定执行。
        </p>
        <h4>4.4 交易争议处理</h4>
        <p>
          <strong>【交易争议处理途径】</strong
          >除本协议另有明确约定外，您在交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
        </p>
        <p>（一）与争议相对方自主协商；</p>
        <p>（二）使用Milky Cloud及其关联平台提供的争议调处服务；</p>
        <p>（三）请求消费者协会或者其他依法成立的调解组织调解；</p>
        <p>（四）向有关行政部门投诉；</p>
        <p>（五）根据与争议相对方达成的仲裁协议提请仲裁机构仲裁；</p>
        <p>（六）向人民法院提起诉讼。</p>
        <p>
          <strong>【平台调处服务】</strong>如您依据Milky
          Cloud及其关联平台规则使用Milky
          Cloud及其关联平台的争议调处服务，则表示您认可并愿意履行Milky
          Cloud及其关联平台的客服（以下简称“调处方”）作为独立的第三方根据其所了解到的争议事实并依据Milky
          Cloud及其关联平台规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在Milky
          Cloud及其关联平台调处决定作出前，您可选择上述（三）、（四）、（五）、（六）途径（以下简称“其他争议处理途径”）解决争议以中止Milky
          Cloud及其关联平台的争议调处服务。如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。
        </p>
        <h4>4.5 信息交流</h4>
        <p>
          为满足用户间分享购物心得等信息交流需求，您可通过Milky
          Cloud及其关联平台提供的社区、晒单分享及其他信息发布功能公开发布信息及与其他用户互动，信息的形式包括文字、图片、视频、直播内容等，您须确保您所发布的所有信息均符合相关法律法规及本协议的要求。
        </p>
        <h4>4.6 行为规范</h4>
        <p><strong>4.6.1 禁止行为</strong></p>
        <p>
          您不得进行任何侵犯Milky
          Cloud及其关联平台知识产权的行为，或者进行其他有损Milky
          Cloud及其关联平台或其他用户合法权益的行为，包括但不限于：
        </p>
        <p>（一）删除或修改Milky Cloud及其关联平台上的版权信息；</p>
        <p>
          （二）对Milky
          Cloud及其关联平台及其中的相关信息擅自出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，借助Milky
          Cloud及其关联平台发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；
        </p>
        <p>
          （三）在Milky
          Cloud及其关联平台中内置各种插件程序或者其他的第三方程序，或者制作、发布、传播上述程序，而无论是否出于商业目的；
        </p>
        <p>
          （四）进行编译、反编译、反向工程或者以其他方式破解Milky
          Cloud及其关联平台的行为；
        </p>
        <p>
          （五）使用Milky Cloud及其关联平台外挂和/或利用Milky
          Cloud及其关联平台当中的BUG来获得不正当的利益；
        </p>
        <p>
          （六）利用劫持域名服务器等技术非法侵入、破坏Milky
          Cloud及其关联平台的服务器软件系统，或者修改、增加、删除、窃取、截留、替换Milky
          Cloud及其关联平台的客户端和/或服务器软件系统中的数据，或者非法挤占Milky
          Cloud及其关联平台的服务器空间，或者实施其他的使之超负荷运行的行为；
        </p>
        <p>
          （七）假冒Milky Cloud及其关联平台或商家在Milky
          Cloud及其关联平台当中发布任何诈骗或虚假信息；
        </p>
        <p>（八）利用Milky Cloud及其关联平台故意传播恶意程序或计算机病毒。</p>
        <p><strong>4.6.2 信息发布</strong></p>
        <p>
          您应当遵守国家有关法律法规，不得在Milky
          Cloud及其关联平台当中发表、转发或者传播含有下列内容的信息：
        </p>
        <p>（一）违反国家法律法规禁止性规定的；</p>
        <p>
          （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
        </p>
        <p>（三）欺诈、虚假、不准确或存在误导性的；</p>
        <p>（四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</p>
        <p>（五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</p>
        <p>
          （六）存在可能破坏、篡改、删除、影响Milky
          Cloud及其关联平台任何系统正常运行或未经授权秘密获取Milky
          Cloud及其关联平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
        </p>
        <p>
          （七）其他违背社会公共利益或公共道德或依据Milky
          Cloud及其关联平台相关协议、规则的规定不适合在Milky
          Cloud及其关联平台网站上发布的。
        </p>
        <p><strong>4.6.3 法律责任</strong></p>
        <p>
          您需要对您在Milky
          Cloud及其关联平台的言论及行为承担法律责任，若您违反国家法律法规的规定，Milky
          Cloud及其关联平台的系统记录有可能成为您违反法律法规的证据。Milky
          Cloud及其关联平台一旦发现前述情形可采取关闭订单、限制交易、删除信息、账号限权、终止服务等处理措施。
        </p>
        <h4>4.7 免责声明</h4>
        <p>
          <strong>【不可抗力及第三方原因】</strong>Milky
          Cloud及其关联平台依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，Milky
          Cloud及其关联平台并不承担相应的违约责任：
        </p>
        <p>
          （一）在Milky
          Cloud及其关联平台已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
        </p>
        <p>
          （二）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
        </p>
        <p>
          （三）因基础运营商或主管部门故障、电力供应故障、通讯网络故障等公共服务因素或第三人因素；
        </p>
        <p>
          （四）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。
        </p>
        <p>
          （五）尽管有前款约定，Milky Cloud将采取合理行动积极促使服务恢复正常。
        </p>

        <h3>五、用户信息的保护及授权</h3>
        <p>
          <strong>【个人信息的保护】</strong>Milky
          Cloud及其关联平台非常重视用户个人信息的保护，在您使用Milky
          Cloud及其关联平台提供的服务时，您同意Milky
          Cloud及其关联平台按照隐私权政策收集、存储、使用、披露和保护您的个人信息。Milky
          Cloud及其关联平台希望通过隐私权政策向您清楚地介绍Milky
          Cloud及其关联平台对您个人信息的处理方式，因此Milky
          Cloud及其关联平台建议您完整地阅读隐私权政策，以帮助您更好地保护您的隐私权。
        </p>
        <p>
          您同意Milky
          Cloud及其关联平台拥有通过邮箱、短信、电话、微信等形式，向您或收货人发送订单信息、促销活动等告知信息权利。
        </p>
        <p>
          <strong>【授权使用】</strong>对于您提供、发布及在使用Milky
          Cloud及其关联平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，除非我们另行说明，在法律允许的范围内，您免费授予Milky
          Cloud及其关联平台及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。
        </p>

        <h3>六、用户的违约及处理</h3>
        <h4>6.1 违约认定</h4>
        <p>发生如下情形之一的，视为您违约：</p>
        <p>（一）使用Milky Cloud及其关联平台服务时违反有关法律法规规定的；</p>
        <p>（二）违反本协议或本协议之补充协议约定的。</p>
        <p>
          您理解并认可，基于互联网服务的特点，Milky
          Cloud及其关联平台将利用大数据分析和人工抓取相结合的方式，对用户的行为进行抓取、分析和判断。Milky
          Cloud及其关联平台仅需要证明用户行为与普通用户比较，存在明显异常且该异常与违规之间存在关联性，即可认定用户存在涉嫌违约行为。用户有义务在指定时间内提供证据合理解释其行为。如Milky
          Cloud及其关联平台认定用户对异常行为的解释不合理或举证不充分，则Milky
          Cloud及其关联平台可认定用户违约成立并最终依照本协议及相关规则进行处理。
        </p>
        <h4>6.2 违约处理措施</h4>
        <p>
          <strong>【信息处理】</strong>您在Milky
          Cloud及其关联平台上发布的信息构成违约的，Milky
          Cloud及其关联平台可根据本协议及相应规则立即对相应信息采取删除、屏蔽处理等处置措施。
        </p>
        <p>
          <strong>【行为限制】</strong>您在Milky
          Cloud及其关联平台上实施的行为，或虽未在Milky
          Cloud及其关联平台上实施但对Milky
          Cloud及其关联平台及其用户产生影响的行为构成违约的，Milky
          Cloud及其关联平台可依据本协议及相应规则对您采取账号限权、限制交易、关闭订单、中止向您提供部分或全部服务等处置措施。如您的行为构成根本违约或造成严重后果的，Milky
          Cloud及其关联平台可查封您的账号，终止向您提供服务。
        </p>
        <p>
          <strong>【处理结果公示】</strong>Milky
          Cloud及其关联平台可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在Milky
          Cloud及其关联平台上予以公示。
        </p>
        <h4>6.3 赔偿责任</h4>
        <p>
          如您的行为使Milky
          Cloud及其关联平台和/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿Milky
          Cloud及其关联平台和/或其关联公司的全部损失。
        </p>
        <p>
          如您的行为使Milky
          Cloud及其关联平台和/或其关联公司遭受第三人主张权利，Milky
          Cloud及其关联平台和/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。
        </p>
        <p>
          如因您的行为使得第三人遭受损失或您怠于履行调处决定，您同意Milky
          Cloud及其关联平台和/或其关联公司有权出于社会公共利益保护目的、使用自有资金代您偿付相关款项，您应当向Milky
          Cloud及其关联平台和/或其关联公司返还该代偿费用并赔偿因此给Milky
          Cloud及其关联平台和/或其关联公司造成的全部损失。
        </p>

        <h3>七、协议的变更</h3>
        <p>
          Milky
          Cloud及其关联平台可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过页面公告通知您。
        </p>
        <p>
          如您不同意变更事项，您有权于变更事项确定的生效日前联系Milky
          Cloud及其关联平台反馈意见。如反馈意见得以采纳，Milky
          Cloud及其关联平台将酌情调整变更事项。
        </p>
        <p>
          如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用Milky
          Cloud及其关联平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用Milky
          Cloud及其关联平台服务，则视为您同意已生效的变更事项。
        </p>

        <h3>八、通知</h3>
        <h4>8.1 有效联系方式</h4>
        <p>
          您在注册成为Milky Cloud及其关联平台用户，并接受Milky
          Cloud及其关联平台服务时，您应该向Milky
          Cloud及其关联平台提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
        </p>
        <p>
          您在注册Milky Cloud及其关联平台用户时生成的用于登录Milky
          Cloud及其关联平台接收系统消息、通知消息等信息的账号，也作为您的有效联系方式。
        </p>
        <p>
          Milky
          Cloud及其关联平台对于用户所有的通知均可通过页面公告、电子邮件、站内消息、手机短信或常规的信件传送等方式进行。
        </p>
        <p>
          您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过Milky
          Cloud及其关联平台提供的相应的退订功能进行退订。
        </p>
        <h4>8.2 通知的送达</h4>
        <p>
          Milky
          Cloud及其关联平台通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括在Milky
          Cloud及其关联平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送通知信息、系统消息等，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
        </p>
        <p>
          对于在Milky
          Cloud及其关联平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、系统信息通知等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、微信号等联系方式为您在Milky
          Cloud及其关联平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册Milky
          Cloud及其关联平台用户时生成洋葱账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
        </p>
        <p>
          您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。
        </p>
        <p>
          您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
        </p>
        <p>
          您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
        </p>

        <h3>九、协议的终止</h3>
        <h4>9.1 终止的情形</h4>
        <p>
          <strong>【用户发起的终止】</strong>您有权通过以下任一方式终止本协议：
        </p>
        <p>
          （一）在满足Milky
          Cloud及其关联平台公示的账号注销条件时您通过网站自助服务注销您的账号的；
        </p>
        <p>（二）变更事项生效前您停止使用并明示不愿接受变更事项的；</p>
        <p>
          （三）您明示不愿继续使用Milky Cloud及其关联平台服务，且符合Milky
          Cloud及其关联平台终止条件的。
        </p>
        <p>
          <strong>【Milky Cloud及其关联平台发起的终止】</strong
          >出现以下情况时，Milky
          Cloud及其关联平台有权依据本协议第八条的所列的方式通知您终止本协议：
        </p>
        <p>
          （一）您违反本协议约定，Milky
          Cloud及其关联平台依据违约条款终止本协议的；
        </p>
        <p>
          （二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，Milky
          Cloud及其关联平台依据Milky Cloud及其关联平台规则对您的账号予以查封的；
        </p>
        <p>
          （三）除上述情形外，因您多次违反Milky
          Cloud及其关联平台规则相关规定且情节严重，Milky
          Cloud及其关联平台依据Milky Cloud及其关联平台规则对您的账号予以查封的；
        </p>
        <p>（四）您的账号被Milky Cloud及其关联平台依据本协议回收的；</p>
        <p>（五）其它应当终止服务的情况。</p>
        <h4>9.2 协议终止后的处理</h4>
        <p>
          <strong>【用户信息披露】</strong
          >本协议终止后，除法律有明确规定外，Milky
          Cloud及其关联平台无义务向您或您指定的第三方披露您账户中的任何信息。
        </p>
        <p>
          <strong>【Milky Cloud及其关联平台权利】</strong>本协议终止后，Milky
          Cloud及其关联平台仍享有下列权利：
        </p>
        <p>
          （一）继续保存您留存于Milky
          Cloud及其关联平台的本协议第五条所列的各类信息；
        </p>
        <p>
          （二）对于您过往的违约行为，Milky
          Cloud及其关联平台仍可依据本协议向您追究违约责任。
        </p>
        <p>
          <strong>【交易处理】</strong
          >本协议终止后，对于您在本协议存续期间产生的交易订单，Milky
          Cloud及其关联平台可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
        </p>

        <h3>十、 法律适用、管辖与其他</h3>
        <p>
          <strong>【法律适用】</strong
          >本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用澳大利亚（尤其是CODECREST
          INTERNATIONAL PTY
          LTD注册所在地）现行有效的法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
        </p>
        <p>
          <strong>【管辖法院】</strong>您因使用Milky Cloud服务所产生及与Milky
          Cloud服务有关的争议，由Milky
          Cloud与您协商解决。协商不成时，任何一方均可将争议提交澳大利亚有管辖权的法院提起诉讼。
        </p>
        <p>
          <strong>【可分性】</strong
          >本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
        </p>
        <p>
          <strong>【权利放弃】</strong
          >本协议任何一方于另一方过失或违约时放弃本协议规定的权利的，不得视为其对一方的其他或以后同类之过失或违约行为弃权。Milky
          Cloud未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "Login1",
  components: {
    TitleBarBack
  },
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.ifrem_pos {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  &.has-scroll {
    overflow-y: auto; /* 保障超长内容可滚动 */
  }
}

.agreement-container {
  padding: 20px 16px 40px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;

  .title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
  }

  .date {
    font-size: 13px;
    color: #666;
    text-align: right;
    margin-bottom: 30px;
    line-height: 1.8;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 24px 0 12px;
  }

  h4 {
    font-size: 15px;
    font-weight: 600;
    margin: 16px 0 8px;
  }

  p {
    margin-bottom: 12px;
    text-align: justify;
    word-break: break-all;
  }
}
</style>
